import { render, staticRenderFns } from "./msgtypeText.vue?vue&type=template&id=30ce2f4a&scoped=true&"
import script from "./msgtypeText.vue?vue&type=script&lang=js&"
export * from "./msgtypeText.vue?vue&type=script&lang=js&"
import style0 from "./msgtypeText.vue?vue&type=style&index=0&id=30ce2f4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ce2f4a",
  null
  
)

export default component.exports